<div class="login-page1">
<div class="modal-dialog login-modal modal-ui">
    <div class="modal-content">
        <!-- <div class="modal-header">
        </div> -->
        <div class="modal-body">
          <div class="container-fluid">

            <div class="row align-items-center">
              <div class="col-md-5 loginleft">
                <div class="text-center my-2">
                    <img class="img-fluid logoLoginPage" src="assets/img/{{env.host.name}}/logo.png" alt="">
                    <img class="img-fluid filterlogin" src="assets/img/loginImg2.png">
                </div>
              </div>
              <div class="col-md-7 loginright">
                  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <p>Welcome please login to your account</p>
                    <div class="form-group">
                      <input class="form-control" name="User Name" formControlName="username" type="text" id="" required="" placeholder="Enter Username">
                      <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">The User Name field is required</div>
                      </div>
                    </div>

                    <div class="form-group">
                      <input class="form-control" name="Password" formControlName="password" type="password" required="" id="" placeholder="Enter Password">
                      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">The Password field is required</div>
                      </div>
                    </div>

                    <div class="form-group">
<!--                      <div class="custom-control custom-checkbox">-->
<!--                        <input type="checkbox" class="custom-control-input" id="customCheck2">-->
<!--                        <label class="custom-control-label" for="customCheck2">Remember me</label>-->
<!--                      </div>-->

                      <small>This site is protected by reCAPTCHA and the Google <a href="#">Privacy Policy</a> and <a
                          href="#">Terms of Service apply</a>.</small>
                    </div>

                    <div class="form-group text-right">
                      <button type="submit" class="btn btn-login">Log In</button>
                    </div>
                  </form>
              </div>
            </div>

          </div>
        </div>
    </div>
  </div>
  </div>

  <div class="modal fade bg-dark" bsModal #changePwd="bs-modal" [config]="{backdrop: true}" tabindex="-1" role="dialog"
    aria-labelledby="dialog-static-name">
    <div class="modal-dialog login-modal modal-ui cpmodal modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pull-left" id="">Change Password</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="changePwd.hide()">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>
            <div class="modal-body">
              <app-change-password class="modal-change-pwd" (openLogin)="loginRoute()" [isModal]="true">
              </app-change-password>
            </div>
        </div>
    </div>
</div>
